export default {
  character: {
    results: [],
  },
  units: {
    results: [],
  },
}
